import SidebarBookingsRepliesIndexController from 'uplisting-frontend/pods/-sidebar/bookings/replies/index/controller';

export default class ProtectionOverviewBookingsRepliesIndexController extends SidebarBookingsRepliesIndexController {}
